import { Modal, Tabs, TabsProps } from 'antd';
import React, { FC } from 'react';
import {
  TDivisionResponse,
  TOrganizationResponse,
  useLazyGetAdsDivisionsQuery,
  useLazyGetAdsOrganizationsQuery,
} from 'app/services/edpApiV1/moderator';
import { TAddUserEmployee } from 'shared/types/news.types';
import UsersSearch from './usersSearch/UsersSearch';
import DivisionsSearch from './divisionsSearch/DivisionsSearch';
import OrganizationsSearch from './organizationsSearch/OrganizationsSearch';

type TModalAddUsersProps = {
  open: boolean;
  onOk: (val: TAddUserEmployee[]) => void;
  onCancel: () => void;
  selectedUsers?: TAddUserEmployee[];
  addUsers: (users: TAddUserEmployee[]) => void;
  selectedDivisions?: TDivisionResponse[];
  addDivisions: (divisions: TDivisionResponse[]) => void;
  selectedOrganizations?: TOrganizationResponse[];
  addOrganizations: (divisions: TOrganizationResponse[]) => void;
};

const ModalAddUsers: FC<TModalAddUsersProps> = ({
  onCancel,
  onOk,
  open,
  selectedUsers,
  addUsers,
  addDivisions,
  selectedDivisions,
  addOrganizations,
  selectedOrganizations,
}) => {
  const [getDivisionsQuery, { data, isFetching }] = useLazyGetAdsDivisionsQuery();
  const [getOrganizationsQuery, { data: organizationsData, isFetching: organizationsFetching }] =
    useLazyGetAdsOrganizationsQuery();

  const onModalSubmit = () => {
    if (selectedUsers) {
      onOk(selectedUsers);
    }
  };
  const onModalCancel = () => {
    onCancel();
  };

  const items: TabsProps['items'] = [
    {
      key: 'users',
      label: 'Пользователи',
      children: <UsersSearch selectedUsers={selectedUsers} addUsers={addUsers} />,
    },
    {
      key: 'divisions',
      label: 'Подразделения',
      children: (
        <DivisionsSearch
          getDivisionsQuery={getDivisionsQuery}
          data={data}
          isFetching={isFetching}
          addDivisions={addDivisions}
          selectedDivisions={selectedDivisions}
        />
      ),
    },
    {
      key: 'organizations',
      label: 'Организации',
      children: (
        <OrganizationsSearch
          getOrganizationsQuery={getOrganizationsQuery}
          data={organizationsData}
          isFetching={organizationsFetching}
          addOrganizations={addOrganizations}
          selectedOrganizations={selectedOrganizations}
        />
      ),
    },
  ];

  return (
    <Modal title={<p>Выберите пользователей</p>} open={open} onOk={onModalSubmit} onCancel={onModalCancel} width={850}>
      <Tabs defaultActiveKey="users" items={items} />
    </Modal>
  );
};

export default ModalAddUsers;
